import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  goldIndexes: "goldIndexes [Action]",
  goldIndexesLoading: "goldIndexesLoading [Action]",
  goldIndexesAsync: "goldIndexesAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const goldIndexesReducer = (state = inistiaState, { type, payload }) => {
  switch (type) {
    case actionTypes.goldIndexes:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.goldIndexesLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {

  let config = {
    url: "select_request",
  };

  let data = {
    table: "GOLD",
    method_type: "gold_indexes",
    data: payload?.data ? payload.data : {},
  };
  yield put({
    type: actionTypes.goldIndexesLoading,
    payload: true,
  });
  try {
    let res = yield AxiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }

    yield put({
      type: actionTypes.goldIndexes,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.goldIndexesLoading,
      payload: false,
    });
  }
}

export function* goldIndexes() {
  yield takeLatest(actionTypes.goldIndexesAsync, handleWorker);
}
